{
  "appName": "VynaEMR",
  "appTagline": "ஆசிய-பசிபிக் முதன்மை மின்னணு மருத்துவ பதிவுகள்",
  "developedByLabel": "உருவாக்கியது",
  "loading": "ஏற்றுகிறது...",
  "save": "சேமி",
  "cancel": "ரத்து செய்",
  "delete": "நீக்கு",
  "edit": "திருத்து",
  "create": "உருவாக்கு",
  "search": "தேடு",
  "filter": "வடிகட்டு",
  "actions": "செயல்கள்",
  "confirm": "உறுதிப்படுத்து",
  "back": "பின்செல்",
  "next": "அடுத்து",
  "previous": "முந்தைய",
  "submit": "சமர்ப்பி",
  "reset": "மீட்டமை",
  "close": "மூடு",
  "yes": "ஆம்",
  "no": "இல்லை",
  "ok": "சரி",
  "error": "பிழை",
  "success": "வெற்றி",
  "warning": "எச்சரிக்கை",
  "info": "தகவல்",
  "validation": {
    "required": "இந்த புலம் அவசியமானது",
    "invalidEmail": "தவறான மின்னஞ்சல் முகவரி",
    "invalidPhone": "தவறான தொலைபேசி எண்",
    "invalidDate": "தவறான தேதி",
    "minLength": "குறைந்தபட்சம் {{min}} எழுத்துகள் தேவை",
    "maxLength": "அதிகபட்சம் {{max}} எழுத்துகள் அனுமதிக்கப்படுகின்றன",
    "passwordMismatch": "கடவுச்சொற்கள் பொருந்தவில்லை"
  },
  "form": {
    "fieldRequired": "{{field}} தேவை",
    "selectOption": "தயவுசெய்து ஒரு விருப்பத்தைத் தேர்ந்தெடுக்கவும்",
    "discardConfirm": "சேமிக்கப்படாத மாற்றங்களை நிராகரிக்கவா?",
    "unsavedChanges": "சேமிக்கப்படாத மாற்றங்கள் உள்ளன",
    "mustBeNonNegativeInteger": "{{field}} 0 அல்லது அதற்கு மேற்பட்ட முழு எண்ணாக இருக்க வேண்டும்",
    "mustBeNonNegativeNumber": "{{field}} 0 அல்லது அதற்கு மேற்பட்ட எண்ணாக இருக்க வேண்டும்"
  },
  "unsavedChanges": {
    "title": "சேமிக்கப்படாத மாற்றங்கள்",
    "body": "உங்களிடம் சேமிக்கப்படாத மாற்றங்கள் உள்ளன. இந்தப் பக்கத்தைவிட்டு வெளியேற விரும்புகிறீர்களா? மாற்றங்கள் இழக்கப்படும்.",
    "stay": "இருங்கள்",
    "leave": "வெளியேறு"
  },
  "messages": {
    "saveSuccess": "மாற்றங்கள் வெற்றிகரமாக சேமிக்கப்பட்டன",
    "saveError": "மாற்றங்களைச் சேமிக்க முடியவில்லை",
    "deleteConfirm": "இந்த உருப்படியை நீக்க விரும்புகிறீர்களா?",
    "deleteSuccess": "உருப்படி வெற்றிகரமாக நீக்கப்பட்டது",
    "deleteError": "உருப்படியை நீக்க முடியவில்லை",
    "networkError": "பிணைய பிழை. உங்கள் இணைப்பைச் சரிபார்க்கவும்.",
    "serverError": "சேவையக பிழை. பின்னர் மீண்டும் முயற்சிக்கவும்.",
    "unauthorized": "இந்த செயலைச் செய்ய உங்களுக்கு அனுமதி இல்லை."
  },
  "dateFormat": {
    "short": "DD/MM/YYYY",
    "long": "D MMMM YYYY",
    "withTime": "DD/MM/YYYY HH:mm",
    "timeOnly": "HH:mm"
  },
  "demo": {
    "warning": "இது VynaEMR செயல்விளக்கம் — உண்மையான நோயாளர் தகவலை (PHI) உள்ளிட வேண்டாம்."
  },
  "network": {
    "offline": "நீங்கள் ஆஃப்லைனில் உள்ளீர்கள். மருத்துவ தரவு சேமிக்கப்படாமல் போகலாம்."
  },
  "permissionDenied": {
    "title": "அணுகல் மறுக்கப்பட்டது",
    "body": "{{action}} செய்ய உங்களுக்கு அனுமதி இல்லை.",
    "genericBody": "இந்த ஆதாரத்தைக் காண உங்களுக்கு அனுமதி இல்லை.",
    "requiredPermission": "தேவையான அனுமதி: {{name}}",
    "contactAdmin": "இது தவறு என்று நீங்கள் நினைத்தால், உங்கள் கணினி நிர்வாகியைத் தொடர்பு கொள்ளவும்.",
    "requiresPermissionCode": "அனுமதி தேவை: {{code}}",
    "requiresLabel": "{{label}} தேவை",
    "requiresLabelWithRoles": "{{label}} தேவை (வைத்திருப்பவர்: {{roles}})",
    "insufficient": "போதிய அனுமதிகள் இல்லை"
  },
  "skipToContent": "முதன்மை உள்ளடக்கத்திற்குச் செல்",
  "openMenu": "மெனுவைத் திற",
  "topBar": {
    "searchPlaceholder": "நோயாளரைத் தேடு (MRN, பெயர், ID)...",
    "recentPatients": "சமீபத்திய நோயாளர்கள்",
    "searching": "தேடுகிறது...",
    "noPatientsFound": "நோயாளர் எதுவும் கிடைக்கவில்லை. தேட Enter அழுத்தவும்.",
    "notifications": "அறிவிப்புகள்",
    "selectFacility": "சுகாதார மையத்தைத் தேர்வுசெய்",
    "allFacilities": "அனைத்து சுகாதார மையங்கள்",
    "facilityLabel": "சுகாதார மையம் {{id}}",
    "activeDepartment": "பணிபுரியும் துறை",
    "selectDepartment": "பணித் துறையைத் தேர்ந்தெடுக்கவும்",
    "noDepartmentSelected": "துறையைத் தேர்ந்தெடுக்கவும்",
    "departmentLabel": "துறை {{id}}",
    "departmentSwitchFailed": "மாற்ற முடியவில்லை"
  },
  "theme": {
    "toggle": "தீம் மாற்று",
    "light": "ஒளி",
    "dark": "இருண்ட",
    "system": "சிஸ்டம்",
    "current": "தீம்: {{name}}"
  },
  "appVersionLabel": "VynaEMR v{{version}}",
  "footerCopyright": "© {{year}}",
  "footerHealthOperational": "செயல்பாட்டில்",
  "footerHealthIssue": "இணைப்புச் சிக்கல்",
  "dobLabel": "பிறந்த தேதி {{date}}",
  "pagination": {
    "previous": "முந்தைய",
    "next": "அடுத்தது",
    "pageOf": "பக்கம் {{current}} / {{total}}",
    "showing": "மொத்தம் {{total}} இல் {{from}} முதல் {{to}} வரை காட்டப்படுகிறது",
    "loadMore": "மேலும் ஏற்றுக"
  },
  "table": {
    "empty": "தரவு இல்லை",
    "loading": "ஏற்றுகிறது..."
  },
  "cdsAlert": {
    "severity": {
      "info": "தகவல்",
      "warning": "எச்சரிக்கை",
      "critical": "தீவிரம்"
    },
    "overridden": "மேலெழுதப்பட்டது",
    "acknowledged": "ஒப்புக்கொள்ளப்பட்டது",
    "justificationPlaceholder": "நியாயப்படுத்தும் காரணத்தை உள்ளிடவும்...",
    "submit": "சமர்ப்பி",
    "acknowledge": "ஒப்புக்கொள்",
    "override": "மேலெழுது",
    "regionAria": "மருத்துவ முடிவு ஆதரவு (CDS) எச்சரிக்கைகள்",
    "acknowledgeFailed": "ஒப்புதலைப் பதிவு செய்ய முடியவில்லை — அது சேமிக்கப்படவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "overrideFailed": "மேலெழுதலைப் பதிவு செய்ய முடியவில்லை — அது சேமிக்கப்படவில்லை. மீண்டும் முயற்சிக்கவும்.",
    "addressedCount_one": "{{count}} தீர்க்கப்பட்டது",
    "addressedCount_other": "{{count}} தீர்க்கப்பட்டது"
  },
  "components": {
    "printButton": {
      "defaultLabel": "அச்சிடு"
    },
    "codeSearch": {
      "searchPlaceholder": "குறியீடுகளைத் தேடுக...",
      "clearAriaLabel": "தேர்வை அழி",
      "noCodesFound": "குறியீடுகள் எதுவும் இல்லை"
    },
    "demographicPicker": {
      "addPlaceholder": "சேர்க்கவும்…",
      "loading": "ஏற்றப்படுகிறது…",
      "noneRecorded": "பதிவு இல்லை",
      "removeAriaLabel": "{{value}} அகற்று",
      "unavailable": "மதிப்புப் பட்டியல் கிடைக்கவில்லை",
      "unavailableHint": "மதிப்புப் பட்டியலை ஏற்ற முடியவில்லை. தற்போதைய மதிப்புகள் மாறாமல் சேமிக்கப்படும்.",
      "uncodedBadge": "குறியீட்டப்படாத",
      "uncodedTitle": "குறியீட்டு மதிப்புகள் வருவதற்கு முன் பதிவு செய்யப்பட்டது. அகற்றலாம், ஆனால் மீண்டும் சேர்க்க முடியாது."
    }
  },
  "pages": {
    "accessDenied": {
      "title": "அணுகல் மறுக்கப்பட்டது",
      "httpStatus": "HTTP 403",
      "body": "இந்தப் பக்கத்தைப் பார்க்க உங்களுக்கு அனுமதி இல்லை.",
      "attemptedLabel": "முயற்சித்த முகவரி:",
      "requiredPermissionLabel": "தேவையான அனுமதி:",
      "typicallyHeldByLabel": "வழக்கமாக இந்த அனுமதியை வைத்திருக்கும் பாத்திரங்கள்:",
      "signedInAs": "உள்நுழைந்தவர்:",
      "contactAdminHelp": "இது தவறு என நீங்கள் கருதினால், தேவையான பாத்திரத்தைக் கோர அமைப்பு நிர்வாகி அல்லது துறைத் தலைவரைத் தொடர்பு கொள்ளவும்.",
      "goBack": "திரும்பு",
      "dashboard": "டாஷ்போர்டு",
      "contact": "தொடர்பு"
    },
    "notificationInbox": {
      "title": "அறிவிப்புகள்",
      "markAllRead": "அனைத்தையும் படித்ததாகக் குறி",
      "loading": "அறிவிப்புகள் ஏற்றப்படுகின்றன…",
      "errorState": "அறிவிப்புகளை ஏற்ற முடியவில்லை.",
      "emptyState": "அறிவிப்புகள் எதுவும் இல்லை.",
      "ariaFilterStatus": "நிலையின் அடிப்படையில் வடிகட்டு",
      "ariaFilterPriority": "முன்னுரிமை அடிப்படையில் வடிகட்டு",
      "ariaFilterType": "வகை அடிப்படையில் வடிகட்டு",
      "filterStatus": {
        "all": "அனைத்தும்",
        "unread": "படிக்காதவை",
        "read": "படித்தவை"
      },
      "filterPriority": {
        "allLabel": "அனைத்து முன்னுரிமைகள்",
        "critical": "மிக அவசரம்",
        "high": "உயர்",
        "normal": "சாதாரண",
        "low": "குறைந்த"
      },
      "filterType": {
        "allLabel": "அனைத்து வகைகள்"
      },
      "notificationType": {
        "criticalResult": "மிக அவசர முடிவு",
        "orderUpdate": "உத்தரவு புதுப்பிப்பு",
        "appointmentReminder": "முன்பதிவு நினைவூட்டல்",
        "systemAlert": "கணினி எச்சரிக்கை",
        "cdsAlert": "மருத்துவ முடிவு ஆதரவு எச்சரிக்கை",
        "result": "பரிசோதனை முடிவு",
        "handoffAssigned": "பொறுப்பு ஒப்படைப்பு"
      },
      "toasts": {
        "allMarkedRead": "அனைத்து அறிவிப்புகளும் படித்ததாகக் குறிக்கப்பட்டன",
        "markAllReadFailed": "அனைத்து அறிவிப்புகளையும் படித்ததாகக் குறிக்க முடியவில்லை",
        "markReadFailed": "அறிவிப்பை படித்ததாகக் குறிக்க முடியவில்லை"
      }
    },
    "entityResolver": {
      "invalidId": "இந்த இணைப்பு செல்லுபடியாகாது.",
      "notFound": "கிடைக்கவில்லை, அல்லது உங்களுக்கு அணுகல் இல்லை."
    }
  },
  "license": {
    "evalBanner": "Evaluation license: {{count}} days left.",
    "graceBanner": "License issue: service continues for {{count}} more hours.",
    "expiringBanner": "License expires soon: {{count}} days left. Renew now to avoid service refusal.",
    "saasUnkeyedBanner": "Organization license not installed. Premium modules are open during rollout.",
    "saasUnverifiableBanner": "Organization license cannot be verified. Premium modules are open; contact support.",
    "expiredBanner": "License expired. Requests are being refused.",
    "invalidBanner": "License invalid. Requests are being refused.",
    "viewLicense": "View license"
  },
  "wsDown": {
    "title": "நேரலை புதுப்பிப்புகள் கிடைக்கவில்லை",
    "body": "இணைப்பு மீட்கப்படும் வரை புதிய முடிவுகளும் எச்சரிக்கைகளும் தானாக வராது.",
    "authBody": "உங்கள் அமர்வு காலாவதாகிவிட்டது. நேரலை புதுப்பிப்புகளை மீட்க மீண்டும் உள்நுழையவும்.",
    "retry": "மீண்டும் முயல்க",
    "login": "உள்நுழைக"
  }
}
